export default __webpack_public_path__ + "static/media/rusenje-cover.6c3143d6.jpg";